import React from "react";

import { useDictionary } from "hooks";

import styles from "./styles.css";

const defaultDictionary = {
	title: "Another user continues to make changes to the same field(s) that are overwriting your inputs. Review the impacted field(s) below. Since this conflict has occurred multiple times, please refresh your page and try again later.",
	enteredValue: "Your entered value",
	currentValue: "Current value",
};

export const RetryModal = ({ fields }) => {
	const dictionary = useDictionary("common.retryModal");

	return (
		<React.Fragment>
			<h4 className={styles.title}>
				{dictionary.title || defaultDictionary.title}
			</h4>
			<ul className={styles.list}>
				{fields.map((item, k) => (
					<li key={k}>
						<p>{item.sectionName}: {item.fieldName}</p>
					</li>
				))}
			</ul>
		</React.Fragment>
	);
};
